import * as moment from 'moment';
import Moment = moment.Moment;
import 'moment/locale/da';
import {Order} from './order';
import {ShipmentDriver} from './shipment-driver';

export class ShipmentRoute {

    static _JSONProps: string[] = [
        'id',
        'sort',
        'name',
        'driver',
        'driver_initials',
        'shipment_driver_id',
        'trip',
        'branch',
        'last_x',
        'last_y',
        'is_global'
    ];

    id: string;
    sort: number;
    name: string;
    driver: string;
    driver_initials: string;
    shipment_driver_id: string;
    trip: string;
    branch: string;
    last_position: Moment;
    last_x: number;
    last_y: number;
    created: Moment;
    modified: Moment;
    shipment_driver?: ShipmentDriver;
    route_color?: string;
    is_global?: boolean;

    static routeColors = {
        'hoe': [
            {'color': '#7A1020', 'label': 'A'},
            {'color': '#7A3A10', 'label': 'B'},
            {'color': '#7A6A10', 'label': 'C'},
            {'color': '#103A7A', 'label': 'D'},
            {'color': '#0F5A2A', 'label': 'E'},
            {'color': '#0F5A57', 'label': 'F'}
        ],
        'rin': [
            {'color': '#9E1B32', 'label':  'A'},
            {'color': '#9E4E1B', 'label':  'B'},
            {'color': '#9E861B', 'label':  'C'},
            {'color': '#1B4E9E', 'label':  'D'},
            {'color': '#1A7A3A', 'label':  'E'},
            {'color': '#1A7A76', 'label':  'F'}
        ],
        'var': [
            {'color': '#C62839', 'label': 'A'},
            {'color': '#C66A28', 'label': 'B'},
            {'color': '#C6A928', 'label': 'C'},
            {'color': '#286AC6', 'label': 'D'},
            {'color': '#2E9E4D', 'label': 'E'},
            {'color': '#2E9E9A', 'label': 'F'}
        ],
        'vib': [
            {'color': '#D94A57', 'label':  'A'},
            {'color': '#D9894A', 'label':  'B'},
            {'color': '#D9BF4A', 'label':  'C'},
            {'color': '#4A89D9', 'label':  'D'},
            {'color': '#4AB563', 'label':  'E'},
            {'color': '#4AB5B1', 'label':  'F'}
        ],
        'vid': [
            {'color': '#E76F7A', 'label':  'A'},
            {'color': '#E7A56F', 'label':  'B'},
            {'color': '#E7D56F', 'label':  'C'},
            {'color': '#6FA5E7', 'label':  'D'},
            {'color': '#6FD085', 'label':  'E'},
            {'color': '#6FD0CD', 'label':  'F'}
        ],
        'cla': [
            {'color': '#F2A6AE', 'label':  'A'},
            {'color': '#F2C1A6', 'label':  'B'},
            {'color': '#F2E4A6', 'label':  'C'},
            {'color': '#A6C1F2', 'label':  'D'},
            {'color': '#A6E0B7', 'label':  'E'},
            {'color': '#A6E0DE', 'label':  'F'}
        ],
        'ulf': [
            {'color': '#8E2030', 'label':  'A'},
            {'color': '#8E511E', 'label':  'B'},
            {'color': '#8E7B1E', 'label':  'C'},
            {'color': '#1E519E', 'label':  'D'},
            {'color': '#1E8E47', 'label':  'E'},
            {'color': '#1E8E88', 'label':  'F'}
        ],
        'group_8': [
            {'color': '#B02B44', 'label':  'A'},
            {'color': '#B06B2B', 'label':  'B'},
            {'color': '#B09A2B', 'label':  'C'},
            {'color': '#2B6BB0', 'label':  'D'},
            {'color': '#2BB05A', 'label':  'E'},
            {'color': '#2BB0AA', 'label':  'F'}
        ]
    }

    static fromJSON(json: ShipmentRouteJSON | string): ShipmentRoute {
        if (json === null) {
            return new ShipmentRoute();
        }

        if (typeof json === 'string') {
            return JSON.parse(json, ShipmentRoute.reviver);
        } else {
            const task = Object.create(ShipmentRoute.prototype);

            const extra = {
                last_position: json.last_position ? moment(json.last_position) : null,
                created: moment(json.created),
                modified: moment(json.modified),
                shipment_driver: null,
            };

            Object.keys(json).forEach((key, index) => {
                if (ShipmentRoute._JSONProps.indexOf(key) !== -1) {
                    task[key] = json[key];
                }

                if (key === 'shipment_driver') {
                    extra.shipment_driver = ShipmentDriver.fromJSON(json[key]);
                }
            });

            task.route_color = ShipmentRoute.getDriverColor(task);
            task.ddddd = '3';
            return Object.assign(task, extra);
        }
    }

    static reviver(key: string, value: any): any {
        return key === '' ? ShipmentRoute.fromJSON(value) : value;
    }


    static getDriverColor?(shipmentRoute: ShipmentRoute): string {
        if (!shipmentRoute) {
            return null;
        }
        if (!shipmentRoute.branch) {
            return null;
        }
        const color = this.routeColors[shipmentRoute.branch].find((c) => {
            if (c.label === shipmentRoute.driver) {
                return true;
            }
        });
        if (color) {
            return color.color;
        }
        return '#000';
    }

    constructor(initializer?: ShipmentRouteJSON) {
        if (initializer === undefined) {
            return;
        }
    }
}

// A representation of Token data that can be converted to
// and from JSON without being altered.
export interface ShipmentRouteJSON {
    id?: string;
    name?: string;
    driver?: string;
    trip?: string;
    branch?: string;
    last_x?: number;
    last_y?: number;
    last_position?: Moment;
    created?: Moment;
    modified?: Moment;
    route_color?: string;
    shipment_driver?: ShipmentDriver;
}
